import apiCallsMenuItems from '../../modules/apiCalls/menuItems';
import productCallsMenuItems from '../../modules/productCalls/menuItems';

export default {
  isTempPassword: null,
  abilities: null,
  path: null,
  defaultPath: "/dashboard",
  loading: false,
  overlayInLoading: false,
  fullName: null,
  originalUser: null,
  modals: [],
  menuItems: [
    {
      icon: "mdi-view-dashboard",
      title: "dashboard",
      to: "/dashboard",
    },
    {
      icon: "mdi-domain",
      title: "BusinessGroups",
      to: "/business-groups",
    },
    {
      icon: "mdi-domain",
      title: "Organizations",
      to: "/organizations",
    },
    {
      icon: "mdi-account-multiple",
      title: "clients",
      to: "/clients",
    },
    {
      icon: "mdi-chart-line",
      title: "Trend Reports",
      to: "/trend-reports",
    },
    {
      icon: "mdi-currency-usd",
      title: "Billing",
      group: "/billing",
      children: [
        {
          title: "Pricing Level Groups",
          to: "rules",
          icon: "mdi-format-list-checks",
        },
        {
          title: "Report",
          to: "report",
          icon: "mdi-format-list-checks",
        },
        {
          title: "Revenue Report",
          to: "revenue-report",
          icon: "mdi-format-list-checks",
        },
        {
          title: "Revenue Product Report",
          to: "revenue-product-report",
          icon: "mdi-format-list-checks",
        },
      ],
    },
    {
      icon: "mdi-key",
      title: "API Credentials",
      to: "/api-keys",
    },
    ...apiCallsMenuItems,
    ...productCallsMenuItems,
    {
      icon: "mdi-book-open",
      title: "Documentation",
      to: "/documentation",
    },
    {
      icon: "mdi-camera-iris",
      title: "Risk Engine",
      group: "/risk-engine",
      children: [
        {
          icon: "mdi-run-fast",
          title: "Rules",
          to: "rules",
        },
        {
          icon: "mdi-factory",
          title: "Campaigns",
          to: "campaigns",
        },
      ],
    },
    {
      icon: "mdi-file-export",
      title: "Exports",
      to: "/exports",
    },
    {
      icon: "mdi-format-list-checks",
      title: "Infrastructure",
      group: "",
      children: [
        {
          title: "Scheduler Workers",
          group: "/scheduler-workers",
          children: [
            {
              title: "Report",
              to: "report",
              icon: "mdi-format-list-checks",
            },
            {
              title: "Workers",
              to: "workers",
              icon: "mdi-format-list-checks",
            },
          ],
        },
        {
          title: "Errors list",
          fullPath: true,
          to: "errors-list",
          icon: "mdi-alert-circle",
        },
        {
          title: "Access Control",
          group: "/acl",
          children: [
            {
              title: "Roles",
              to: "roles",
              icon: "mdi-format-list-checks",
            },
            {
              title: "Entities",
              to: "entities",
              icon: "mdi-format-list-checks",
            },
          ],
        },
        {
          title: "Lead Sync",
          fullPath: true,
          to: "sync",
          icon: "mdi-alert-circle",
        },
        {
          title: "Notifications",
          group: "/notifications",
          children: [
            {
              title: "Notifications",
              to: "list",
              icon: "mdi-format-list-checks",
            },
            {
              title: "Notifications Setting",
              to: "setting",
              icon: "mdi-format-list-checks",
            },
          ],
        },
        {
          fullPath: true,
          title: "Click By Dynamic Config",
          to: "click-by-dynamic-configs",
        },
        {
          fullPath: true,
          title: "API Limits",
          to: "api-limits",
        },
        {
          fullPath: true,
          title: "App Config",
          to: "app-configs",
        },
        {
          fullPath: true,
          title: "Insight Models",
          to: "insight-models",
        },
      ],
    },
  ],
};
